import { Reducer } from 'redux';
import {
  UI_IDLE__SET_IDLE_TIMEOUT_STATUS,
  UI_MODALS__SET_MODAL_VISIBLE,
  UI_SPINNERS__SET_ASYNC_SPINNER_VISIBLE,
  UI_SPINNERS__SET_PAYMENT_SPINNER_VISIBLE,
  UI_SPINNERS__SET_SPINNER_VISIBLE,
  UI_ANNOUNCE__VISIBLE,
  UIActions,
  UIState,
  UI_IS_CALENDAR_OPEN,
  UI_IS_MOBILE_NAV_OPEN
} from './types';

const initialState: UIState = {
  idle: {
    isTimeout: false
  },
  spinners: {
    asyncSpinner: {
      count: 0,
      visible: false
    },
    paymentSpinner: {
      visible: false
    }
  },
  modals: {
    idleModalVisible: false,
    memberLoginModalVisible: false,
    memberRegisterNSModalVisible: false,
    homeMainNewsContentModalVisible: false,
    homeTravelInsClaimDocumentsModalVisible: false,
    memberProfileLoginRecordModalVisible: false
  },
  announce: {
    visible: true
  },
  isCalendarOpen: false,
  isMobileNavOpen: false
};

const UIReducer: Reducer<UIState, UIActions> = (state = initialState, action): UIState => {
  switch (action.type) {
    // [Idle] 設置閒置逾時狀態
    case UI_IDLE__SET_IDLE_TIMEOUT_STATUS: {
      return { ...state, idle: { ...state.idle, isTimeout: action.payload.isTimeout } };
    }
    // [Spinners] 設置 Spinner 能見度
    case UI_SPINNERS__SET_SPINNER_VISIBLE: {
      return { ...state, spinners: { ...state.spinners, [action.payload.name + 'Visible']: action.payload.visible } };
    }
    // [Spinners] 設置 Async Spinner 能見度 (Action)
    case UI_SPINNERS__SET_ASYNC_SPINNER_VISIBLE: {
      const count = action.payload.isRequest
        ? state.spinners.asyncSpinner.count + 1
        : state.spinners.asyncSpinner.count - 1;
      const visible = !!count;
      return { ...state, spinners: { ...state.spinners, asyncSpinner: { count, visible } } };
    }
    // [Spinners] 設置 payment Spinner 能見度 (Action)
    case UI_SPINNERS__SET_PAYMENT_SPINNER_VISIBLE: {
      const visible = action.payload.visible;
      return { ...state, spinners: { ...state.spinners, paymentSpinner: { visible } } };
    }
    // [Modals] 設置 Modal 能見度
    case UI_MODALS__SET_MODAL_VISIBLE: {
      return { ...state, modals: { ...state.modals, [action.payload.name + 'Visible']: action.payload.visible } };
    }
    // [Announce] 設置 Announce 能見度
    case UI_ANNOUNCE__VISIBLE: {
      return { ...state, announce: { visible: action.payload.visible } };
    }
    // [isCalendarOpen] 設置 isCalendarOpen
    case UI_IS_CALENDAR_OPEN: {
      return { ...state, isCalendarOpen: action.payload.isCalendarOpen };
    }
    // [isMobileNavOpen] 設置 isMobileNavOpen
    case UI_IS_MOBILE_NAV_OPEN: {
      return { ...state, isMobileNavOpen: action.payload.isMobileNavOpen };
    }
    // Default
    default:
      return state;
  }
};

export default UIReducer;
